import {cloneDeep} from 'lodash';
import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import Utility from '../../util/utilityfunctions';
import {currentResource} from '../../util/utils';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      storeIgua.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function getReviewNotesFilters(state = initialState.rnhFilters, action) {
	switch (action.type) {
		case types.SET_RNH_FILTERS: {
			let rnhFilters = {...action.filters};
			rnhFilters.isLoaded = true;
			return rnhFilters;
		}
		case types.SET_RNH_FILTER: {
			let value = action.value;
			if (!Utility.hasValue(value)) {
				// If filter is being disabled, set to empty array so it's removed from the URL.
				value = [];
			}

			let filters;
			filters = {...state};
			if (action.filterItemName) {
				filters[action.filterItemName] = value;
			}

			// Page number must be reset to 1.
			filters.currentPage = 1;
			filters.isLoaded = true;

			return {
				...state,
				...filters
			};
		}
		case types.CLEAR_RNH_FILTERS: {
			let rnhFilters = cloneDeep(state);

			Object.keys(rnhFilters).forEach((key) => {
				if (currentResource.rnhFilterType.find((x) => x.inDropDown && x.filterType === key)) {
					rnhFilters[key] = [];
				}
			});

			rnhFilters.currentPage = 1;

			return rnhFilters;
		}
		default:
			return state;
	}
}
